var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnlineSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Online_Support"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.93961 9.47999C2.52125 9.47999 2.18207 9.81918 2.18207 10.2376V12.9648C2.18207 13.3832 2.52125 13.7224 2.93961 13.7224C3.35797 13.7224 3.69715 13.3832 3.69715 12.9648V10.2376C3.69715 9.81918 3.35797 9.47999 2.93961 9.47999ZM0.666992 10.2376C0.666992 8.98239 1.68449 7.96484 2.93961 7.96484C4.19473 7.96484 5.21223 8.98239 5.21223 10.2376V12.9648C5.21223 14.22 4.19473 15.2375 2.93961 15.2375C1.68449 15.2375 0.666992 14.22 0.666992 12.9648V10.2376Z",
    fill: "#172B4D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0597 9.47999C14.6414 9.47999 14.3022 9.81918 14.3022 10.2376V12.9648C14.3022 13.3832 14.6414 13.7224 15.0597 13.7224C15.4781 13.7224 15.8173 13.3832 15.8173 12.9648V10.2376C15.8173 9.81918 15.4781 9.47999 15.0597 9.47999ZM12.7871 10.2376C12.7871 8.98239 13.8046 7.96484 15.0597 7.96484C16.3148 7.96484 17.3323 8.98239 17.3323 10.2376V12.9648C17.3323 14.22 16.3148 15.2375 15.0597 15.2375C13.8046 15.2375 12.7871 14.22 12.7871 12.9648V10.2376Z",
    fill: "#172B4D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99993 1.90577C5.23453 1.90577 2.18207 4.95836 2.18207 8.72392V10.2391C2.18207 10.6575 1.84291 10.9966 1.42453 10.9966C1.00615 10.9966 0.666992 10.6575 0.666992 10.2391V8.72392C0.666992 4.12157 4.39777 0.390625 8.99993 0.390625C13.6021 0.390625 17.3329 4.12157 17.3329 8.72392V10.2391C17.3329 10.6575 16.9937 10.9966 16.5753 10.9966C16.1569 10.9966 15.8178 10.6575 15.8178 10.2391V8.72392C15.8178 4.95836 12.7653 1.90577 8.99993 1.90577Z",
    fill: "#172B4D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5776 12.207C16.996 12.207 17.3352 12.5462 17.3352 12.9646V14.4797C17.3352 16.5717 15.6394 18.2676 13.5475 18.2676H10.5173C10.0989 18.2676 9.75977 17.9284 9.75977 17.51C9.75977 17.0916 10.0989 16.7525 10.5173 16.7525H13.5475C14.8026 16.7525 15.8201 15.7349 15.8201 14.4797V12.9646C15.8201 12.5462 16.1592 12.207 16.5776 12.207Z",
    fill: "#172B4D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.99945 19.0264C9.83621 19.0264 10.5145 18.348 10.5145 17.5112C10.5145 16.6744 9.83621 15.9961 8.99945 15.9961C8.1627 15.9961 7.48438 16.6744 7.48438 17.5112C7.48438 18.348 8.1627 19.0264 8.99945 19.0264Z",
    fill: "#172B4D"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineSupport);
export default __webpack_public_path__ + "static/media/onlineSupport.f5315e76eea0eededc757698584130e6.svg";
export { ForwardRef as ReactComponent };